import useDynamicCategoriesRouter from "@/hooks/useDynamicCategoriesRouter";
import SchoolGrades from "./home/SchoolGrades";
import LessonDetails from "./lesson/lessonRefactor/Lesson";
import NotFound from "./NotFound";
import LessonsList from "./teacher/LessonsList";

const DynamicCategoriesRouterComponent = () => {
  const {
    currentCat,
    parts,
    childCats,
    isNotFound,
    isLessonListing,
    isLesson,
  } = useDynamicCategoriesRouter();

  if (isNotFound) return <NotFound />;

  if (isLesson) return <LessonDetails />;

  if (isLessonListing) return <LessonsList />;

  return (
    <SchoolGrades
      grades={childCats}
      parts={parts}
      title={
        currentCat?.name?.indexOf("|") !== -1
          ? currentCat?.name?.split("|")[0]
          : currentCat?.name
      }
    />
  );
};

export default DynamicCategoriesRouterComponent;
